/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React from 'react';

const MFHeroAdvisorCard = () => {

  return (

    <section
      className="
        relative
        overflow-hidden
        rounded-[40px]
        bg-gradient-to-br
        from-green-900
        via-green-800
        to-emerald-700
        px-10
        py-16
        text-white
        shadow-2xl
      "
    >

      {/* BACKGROUND GLOW */}
      <div
        className="
          absolute
          -top-24
          -right-24
          w-96
          h-96
          bg-green-400
          opacity-20
          blur-3xl
          rounded-full
        "
      />

      <div
        className="
          absolute
          bottom-0
          left-0
          w-72
          h-72
          bg-emerald-300
          opacity-10
          blur-3xl
          rounded-full
        "
      />


      {/* MAIN CONTENT */}
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-1 gap-14 items-center">

        {/* LEFT SIDE */}
        <div>

          {/* BADGE */}
          {/*<div*/}
          {/*  className="*/}
          {/*    inline-flex*/}
          {/*    items-center*/}
          {/*    gap-2*/}
          {/*    bg-white/10*/}
          {/*    border*/}
          {/*    border-white/20*/}
          {/*    backdrop-blur-md*/}
          {/*    px-5*/}
          {/*    py-2*/}
          {/*    rounded-full*/}
          {/*    text-sm*/}
          {/*    font-medium*/}
          {/*    mb-8*/}
          {/*  "*/}
          {/*>*/}
          {/*  <span className="w-2 h-2 bg-green-300 rounded-full"></span>*/}

          {/*  AMFI Registered Mutual Fund Distributor*/}
          {/*</div>*/}


          {/* TITLE */}
          <h1
            className="
              text-5xl
              lg:text-6xl
              font-black
              leading-tight
              tracking-tight
              mb-6
            "
          >
            Build Long-Term Wealth
            <br/><br/>
            <span className="text-green-300">
              {' '}Smart Mutual Fund Investing
            </span>
          </h1>


          {/* SUBTEXT */}
          <p
            className="
              text-lg
              text-green-50/90
              leading-relaxed
              max-w-2xl
              mb-10
            "
          >
            Discover high-quality mutual funds, SIP opportunities,
            portfolio diversification strategies, and category insights
            powered by data analytics and professional research.
          </p>


          {/* BUTTONS */}
          <div className="flex flex-wrap gap-4">

            {/*<a*/}
            {/*  href="/mfe/"*/}
            {/*  className="*/}
            {/*    inline-block*/}
            {/*    bg-white*/}
            {/*    text-green-900*/}
            {/*    px-8*/}
            {/*    py-4*/}
            {/*    rounded-2xl*/}
            {/*    font-bold*/}
            {/*    text-lg*/}
            {/*    shadow-lg*/}
            {/*    hover:scale-105*/}
            {/*    transition-all*/}
            {/*  "*/}
            {/*>*/}
            {/*  Explore Funds*/}
            {/*</a>*/}

            {/*<button*/}
            {/*  className="*/}
            {/*    border*/}
            {/*    border-white/30*/}
            {/*    bg-white/10*/}
            {/*    backdrop-blur-md*/}
            {/*    px-8*/}
            {/*    py-4*/}
            {/*    rounded-2xl*/}
            {/*    font-semibold*/}
            {/*    text-lg*/}
            {/*    hover:bg-white/20*/}
            {/*    transition-all*/}
            {/*  "*/}
            {/*>*/}
            {/*  Start SIP*/}
            {/*</button>*/}

          </div>

        </div>


        {/* RIGHT SIDE */}

      </div>

    </section>
  );
};

export default MFHeroAdvisorCard;